<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
        Formulario de instructivo de embarque <span v-if="boarding">{{ boarding.boarding_number }}</span>
      </h1>
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer" no-body>
              <form-wizard
                color="#0074d9"
                errorColor="#ff4136"
                ref="wizard"
                shape="circle"
                stepSize="sm"
                nextButtonText="Siguiente"
                backButtonText="Atrás"
                finishButtonText="Finalizar"
                @on-complete="onComplete"
                title=""
                @on-change="renewInfo"
                subtitle=""
              >
                <tab-content title="Compañias" :before-change="submitFormEmpresas">
                  <formEmpresas :boarding="boarding" ref="formEmpresas"></formEmpresas>
                </tab-content>

                <tab-content title="Información de embarque" :before-change="submitFormInformacionEmbarque">
                  <formInformacionEmbarque :boarding="boarding" ref="formInformacionEmbarque"></formInformacionEmbarque>
                </tab-content>

                <tab-content title="Datos tecnicos de la carga" :before-change="submitFormDatosTecnicos">
                  <formDatostecnicos :boarding="boarding" ref="formDatostecnicos"></formDatostecnicos>
                </tab-content>

                <tab-content title="Detalle Carga">
                  <formDetalleCarga :boarding="boarding" ref="formDetalleCarga"></formDetalleCarga>
                </tab-content>

                <tab-content title="Informacion comercial" :before-change="terminarYGuardar">
                  <formInformacionComercial
                    :boarding="boarding"
                    ref="formInformacionComercial"
                  ></formInformacionComercial>
                </tab-content>
              </form-wizard>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import formEmpresas from "./formEmpresas.vue";
import formInformacionEmbarque from "./formInformacionEmbarque.vue";
import formDatostecnicos from "./formDatostecnicos.vue";
import formInformacionComercial from "./formInformacionComercial.vue";
import formDetalleCarga from "./formDetalleCarga.vue";

import { shuffleArray } from "@/shared/utils";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { bus } from "../../main";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "InstruccionEmbarque",
  components: {
    formEmpresas,
    formInformacionEmbarque,
    formDatostecnicos,
    formInformacionComercial,
    formDetalleCarga
  },
  mounted() {
    this.boardingSaved = false;

    if (this.BoardingID != null) {
      this.loadBoarding(this.BoardingID);
      this.boardingSaved = true;
    } else {
    }
  },
  props: ["BoardingID"],
  data() {
    return {
      boardingSaved: false,
      boarding: {
        id: "",
        custom_agent_company: "",
        exporter_company: "",
        shipper_company: "",
        consignee_company: "",
        notify_company: "",
        refrigerating_plant: "",
        transport_company: "",
        plant: "",
        shipment_date: null,

        vessel: "",
        shipping_line: "",
        loading_port: "",
        destination_port: "",
        sps: "",
        booking_number: "",
        depot: "",
        containers: "",
        seal_number: "",
        bill_loading: "",
        house_bl: "",
        dus_number: "",
        stacking_date: null,
        invoice_date: null,
        cut_date: null,
        etd: null,
        eta: null,
        date_loading: null,
        late_arrival: "",

        air_line: "",
        bl_awb: "",
        airport_departure: "",
        airport_arrival: "",
        fligth: "",
        connection_fligth: "",
        date_delivery_airport: null,
        routing: "",

        invoice_number: "",
        sale_mode: "",
        payment_form: "",
        sale_clause: "",
        freight_mode: "",
        currency: "",
        po_number: "",
        freight: 0,
        insurance: 0,

        ventilation: "",
        temperature: "",
        atmosphere: "",
        gas: "",

        country: "",
        shipment_type: "",
        note: "",
        shipping_detail: [],

        boarding_number: null
      }
    };
  },
  computed: {},
  methods: {
    loadBoarding(a) {
      var padre = this;

      this.$axios
        .get("/api/comex/shipment/" + a + "/")
        .then((res) => {
          this.boarding.country = res.data.country;

          this.boarding.id = res.data.id;
          this.boarding.custom_agent_company = res.data.custom_agent_company;
          this.boarding.exporter_company = res.data.exporter_company;
          this.boarding.shipper_company = res.data.shipper_company;
          this.boarding.consignee_company = res.data.consignee_company;
          this.boarding.notify_company = res.data.notify_company;
          this.boarding.refrigerating_plant = res.data.refrigerating_plant; //Obsoleto
          this.boarding.transport_company = res.data.transport_company;
          this.boarding.plant = res.data.plant;
          this.boarding.shipment_date = res.data.shipment_date;
          this.boarding.invoice_date = res.data.invoice_date;

          this.boarding.vessel = res.data.vessel;
          this.boarding.shipping_line = res.data.shipping_line;
          this.boarding.loading_port = res.data.loading_port;
          this.boarding.destination_port = res.data.destination_port;
          this.boarding.sps = res.data.sps;
          this.boarding.booking_number = res.data.booking_number;
          this.boarding.depot = res.data.depot;
          this.boarding.containers = res.data.containers;
          this.boarding.seal_number = res.data.seal_number;
          this.boarding.bill_loading = res.data.bill_loading;
          this.boarding.house_bl = res.data.house_bl;
          this.boarding.dus_number = res.data.dus_number;
          this.boarding.stacking_date = res.data.stacking_date;
          this.boarding.cut_date = res.data.cut_date;
          this.boarding.etd = res.data.etd;
          this.boarding.eta = res.data.eta;
          this.boarding.date_loading = res.data.date_loading;
          this.boarding.late_arrival = res.data.late_arrival;
          this.boarding.air_line = res.data.air_line;
          this.boarding.bl_awb = res.data.bl_awb;
          this.boarding.airport_departure = res.data.airport_departure;
          this.boarding.airport_arrival = res.data.airport_arrival;
          this.boarding.fligth = res.data.fligth;
          this.boarding.connection_fligth = res.data.connection_fligth;
          this.boarding.date_delivery_airport = res.data.date_delivery_airport;
          this.boarding.routing = res.data.routing;
          this.boarding.invoice_number = res.data.invoice_number;
          this.boarding.sale_mode = res.data.sale_mode;
          this.boarding.payment_form = res.data.payment_form;
          this.boarding.sale_clause = res.data.sale_clause;

          this.boarding.freight = res.data.freight;
          this.boarding.insurance = res.data.insurance;

          this.boarding.freight_mode = res.data.freight_mode;
          this.boarding.currency = res.data.currency;
          this.boarding.po_number = res.data.po_number;
          this.boarding.ventilation = res.data.ventilation;

          this.boarding.temperature = res.data.temperature;
          this.boarding.atmosphere = res.data.atmosphere;
          this.boarding.boarding_number = res.data.boarding_number;
          this.boarding.gas = res.data.gas;

          this.boarding.shipment_type = res.data.shipment_type;
          this.boarding.note = res.data.note;
          this.boarding.client = res.data.client;

          bus.$emit("loadSelectdEdit", "Nada");

          padre.$axios
            .get("/api/comex/shippingdetail/detailed/", {
              params: {
                client: this.$store.getters.user.ID_CLIENTE,
                shipment_id: res.data.id
              }
            })
            .then((res) => {
              this.detail = {
                format: "",
                product: "",
                variety: "",
                specifications: [],
                pallet_quantity: "",
                quantity_boxes: "",
                price_box: "",
                gross_weight: 0,
                net_weight: 0
              };

              for (let i in res.data) {
                this.detail = {
                  format: res.data[i].container,
                  product: { id: res.data[i].product.id, text: res.data[i].product.name },
                  variety: { id: res.data[i].variety.id, text: res.data[i].variety.name },
                  specifications: [],
                  condition: res.data[i].condition,
                  pallet_quantity: res.data[i].pallet_quantity,
                  quantity_boxes: res.data[i].box_quantity,
                  price_box: res.data[i].price_per_box,
                  gross_weight: res.data[i].gross_weight,
                  net_weight: res.data[i].net_weight
                };

                this.boarding.shipping_detail.push(this.detail);
                // console.log(res.data[i]);
              }

              bus.$emit("calcularDetalle");
            })
            .catch((error) => {
              padre.$swal.fire("Problemas al terminar proceso", "", "error");
            });
        })
        .catch((error) => {
          this.$swal.fire("Problemas al terminar proceso", "", "error");
        });
    },
    submitFormEmpresas() {
      var formValidacion = this.$refs.formEmpresas.saveForm();
      if (formValidacion == 0) {
        this.$swal.fire("Campos requeridos o invalidos en el formulario", "", "warning");
        return false;
      } else {
        return true;
      }
    },
    submitFormInformacionEmbarque() {
      var formValidacion = this.$refs.formInformacionEmbarque.saveForm();
      if (formValidacion == 0) {
        this.$swal.fire("Campos requeridos o invalidos en el formulario", "", "warning");
        return false;
      } else {
        if (this.boarding.shipment_type == 2) {
          this.$refs.wizard.changeTab(1, 3);
        } else {
          return true;
        }
      }
    },
    submitFormDatosTecnicos() {
      var formValidacion = this.$refs.formDatostecnicos.saveForm();
      if (formValidacion == 0) {
        this.$swal.fire("Campos requeridos o invalidos en el formulario", "", "warning");
        return false;
      } else {
        return true;
      }
    },
    submitFormInformacionComercial() {
      var formValidacion = this.$refs.formInformacionComercial.saveForm();
      if (formValidacion == 0) {
        this.$swal.fire("Campos requeridos o invalidos en el formulario", "", "warning");
        return false;
      } else {
        return true;
      }
    },
    correctAfterSend() {
      if (this.boarding.stacking_date == "") {
        this.boarding.stacking_date = null;
      }

      if (this.boarding.cut_date == "") {
        this.boarding.cut_date = null;
      }

      if (this.boarding.etd == "") {
        this.boarding.etd = null;
      }

      if (this.boarding.eta == "") {
        this.boarding.eta = null;
      }

      if (this.boarding.date_loading == "") {
        this.boarding.date_loading = null;
      }

      if (this.boarding.invoice_date == "") {
        this.boarding.invoice_date = null;
      }

      if (this.boarding.date_delivery_airport == "") {
        this.boarding.date_delivery_airport = null;
      }

      if (this.boarding.shipment_date == "") {
        this.boarding.shipment_date = null;
      }

      if (this.boarding.shipment_date == "") {
        this.boarding.shipment_date = null;
      }
    },
    terminarYGuardar() {
      if (this.submitFormInformacionComercial() != false) {
        this.correctAfterSend();

        this.$swal
          .fire({
            title: "¿Seguro que quieres terminar?",
            text: "",
            type: "warning",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonText: "Sí"
          })
          .then((result) => {
            if (result.value) {
              if (this.boardingSaved == false) {
                var padre = this;

                this.$axios
                  .post("/api/comex/shipment/", this.boarding)
                  .then((res) => {
                    const formData = {
                      boarding_id: res.data.id,
                      shipping_detail: this.boarding.shipping_detail,
                      client: this.$store.getters.user.ID_CLIENTE
                    };

                    padre.$axios
                      .post("/api/comex/companyform/save_shipping_detail/", formData)
                      .then((res) => {
                        padre.$swal.fire("Operación realizada con éxito", "", "success");

                        padre.$router.push("/exportaciones/listado");

                        return true;
                      })
                      .catch((error) => {
                        padre.$swal.fire("Problemas al terminar proceso", "", "error");

                        return false;
                      });
                  })
                  .catch((error) => {
                    padre.$swal.fire("Problemas al terminar proceso", "", "error");

                    return false;
                  });

                //estoy editando
              } else {
                var padre = this;

                this.$axios
                  .put("/api/comex/shipment/update_shipping/", this.boarding)
                  .then((res) => {
                    const formData = {
                      boarding_id: res.data.id,
                      shipping_detail: this.boarding.shipping_detail,
                      client: this.$store.getters.user.ID_CLIENTE
                    };

                    padre.$axios
                      .put("/api/comex/companyform/update_shipping_detail/", formData)
                      .then((res) => {
                        padre.$swal.fire("Operación realizada con éxito", "", "success");

                        padre.$router.push("/exportaciones/listado");

                        return true;
                      })
                      .catch((error) => {
                        padre.$swal.fire("Problemas al terminar proceso", "", "error");

                        //return false;
                      });
                  })
                  .catch((error) => {
                    padre.$swal.fire("Problemas al terminar proceso", "", "error");

                    return false;
                  });
              }
            } else {
            }
          });
      }
    },
    renewInfo: function (prevIndex, nextIndex) {
      /* console.log("nuevo"+nextIndex);
        console.log("antras"+prevIndex); */

      if (prevIndex > nextIndex && this.boarding.shipment_type == 2 && nextIndex == 2 && prevIndex == 3) {
        // console.log("going backward aqq")
        // this.$refs.wizard.changeTab(2,1)
      }
      if (nextIndex > prevIndex) {
        //console.log("going forward")
      }

      /* if (this.$refs.firstTabForm.validate()) {

          $('#message0').hide();
          $('#message1').hide();
          $('#message2').hide();

          $('#message'+nextIndex).show();
        }  */
    },
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
